import { setAssetGroups } from '@customer/store/slices/filtersSlice';
import { useTranslation } from 'react-i18next';
import { FilterInputProps } from '@customer/filters/types';
import { MultiselectFilter } from './MultiselectFilter';
import { NameIdBasicModel } from '@customer/store/apis/commonModels';
import { useGetVehicleGroupsQuery } from '@customer/store/apis/metadataApi';
import { useMemo } from 'react';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';

export const useAssetGroupOptions = (): DropdownItemProps<string>[] => {
  const { data: vehicleGroups } = useGetVehicleGroupsQuery(undefined, {
    refetchOnMountOrArgChange: 60,
  });

  return useMemo(() => {
    return vehicleGroups
      ? vehicleGroups.map(({ id, n }: NameIdBasicModel) => {
          const value = id.toString();
          return { key: value, value, stringValue: value, label: n };
        })
      : [];
  }, [vehicleGroups]);
};

export const AssetGroupsFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownMultiselectElement>) => {
  const { t } = useTranslation();

  return (
    <MultiselectFilter<string>
      filterName="assetGroups"
      label={label ?? t('AssetGroup')}
      action={setAssetGroups}
      elementRef={elementRef}
      useItemsHook={useAssetGroupOptions}
    />
  );
};

export default AssetGroupsFilter;
